export default [
  { id: "LV-GKQ", type: "P208", color: "BLANCO CON AZUL" },
  { id: "LV-HKQ", type: "P06T", color: "BLANCO CON AZUL" },
];
